<app-loader [isLoading]="isLoading"></app-loader>
@if(isUuid){
<router-outlet></router-outlet>
}@else {

<div class="header">
    <app-title [title]="title" [subtitle]="subtitle"></app-title>
    @if (myroles.can_write) {
    <div class="top">
        <div class="boton">
            <button class="b1" mat-button (click)="goToNewOrganization()">Añadir organigrama</button>
        </div>
    </div>
    }
</div>

<div class="content">


    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
        class="mat-elevation-z8 table">

        <!-- Columna de ID -->
        <!-- <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                ID
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.id}}</span>
            </td>
        </ng-container> -->

        <!-- Columna de Nombre -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                NOMBRE
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.name}}</span>
            </td>
        </ng-container>

        <!-- Columna de Imagen -->
        <ng-container matColumnDef="image">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                IMAGEN
            </th>
            <td mat-cell *matCellDef="let element">
                <!-- <span style="font-size: 16px;">{{element.image}}</span> -->
                <img [src]="element.image" alt="" style="width: 150px; height: auto;">
            </td>
        </ng-container>

        <!-- Columna de Acciones -->
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>
                ACCIONES
            </th>
            <td mat-cell *matCellDef="let element">
                @if (myroles.can_write) {
                <button mat-icon-button class="acciones" (click)="goToOrganization(element)"><mat-icon
                        svgIcon="edit"></mat-icon></button>
                }
                @if (myroles.can_delete) {
                <button mat-icon-button class="acciones" (click)="deleteSelected(element.id, element.name)"><mat-icon
                        svgIcon="delete"></mat-icon></button>
                }
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
</div>
}